module.exports = __webpack_public_path__ + "img/4.8d1b2829.jpg";